import React from 'react';
import {
  getItemBySession,
  itemType
} from 'MMT-UI/storages/client/sessionStorage';
import queryString from 'query-string';
import { getServerUrl } from '../../utils/domainMapping';
import { resetTimer } from '../../utils/timer';
import { STORAGE_CONSTANTS } from '../../constants/TrainConstants';
class IRCTCCaptchaPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      encryptedMMTBookingId: '',
      currentMMTBookingId: '',
      verifiedUserId: '',
      irctcBookingId: '',
      allSet: false,
      mmtId: '',
    };

  }

  componentWillMount() {
    const queryParams = queryString.parse(this.props.location.search);
    const encryptedMmtId = queryParams.encryptedMmtId || queryParams.mmtId;
    let currentMMTBookingId = null;
    try {
      currentMMTBookingId = JSON.parse(localStorage.getItem('currentMMTBookingId'));
    } catch (e) {
      currentMMTBookingId = null;
    }
    if (encryptedMmtId) {
      try {
        localStorage.setItem('currentMMTBookingId', JSON.stringify(encryptedMmtId));
      } catch (e) { /* ignore */ }
      currentMMTBookingId = encryptedMmtId;
    }
    let verifiedUserId;
    if (queryParams.irctcUserId) {
      verifiedUserId = queryParams.irctcUserId;
    }
    else {
      verifiedUserId = getItemBySession(
        STORAGE_CONSTANTS.VERIFIED_USER_ID,
        { isPiiData: true, shouldParseJson: true },
        itemType.ES
      );
    }
    this.setState({
      verifiedUserId,
      currentMMTBookingId,
      encryptedMMTBookingId: encryptedMmtId,
      mmtId: queryParams.mmtId,
    });

    this.props.getIRCTCBookingId(encryptedMmtId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.irctcBookingId.length!==0) {
      this.setState({
        irctcBookingId: nextProps.irctcBookingId,
        ...(nextProps?.verifiedUserId && { verifiedUserId: nextProps.verifiedUserId }),
        allSet: true,
      });
      const form = document.getElementById('irctcForm');
      setTimeout(() => {
        resetTimer(this.state.currentMMTBookingId || this.state.encryptedMMTBookingId);
        form && form.submit();
      }, 2500);
    }
  }

  render() {
    const { verifiedUserId, irctcBookingId, encryptedMMTBookingId } = this.state;
    const encodedURI = `${getServerUrl()}/thankYou?bookingId=${encryptedMMTBookingId}`;
    return (
      <div>
        <div className="railLoader" />
        <p className="pageRedirectionMessage textCenter">
          <p>
            Redirecting you to IRCTC website. Please <span className="latoBlack">enter your IRCTC Password in the next screen</span> to complete your booking. Website may take a few seconds to load.
          </p>
          <p>
            NOTE: <span className="latoBlack">If you face issues, click on the 'Forgot Password' button</span> to access MMT retry options.
          </p>
        </p>
        <form id = "irctcForm" action="https://www.aps.irctc.co.in/eticketing/wsapplogin" method="post" >
          <input id = "loginId" type="hidden" name="wsloginId" value={verifiedUserId}/>
          <input id = "taxId" type="hidden" name="wsTxnId" value={irctcBookingId} />
          <input id = "wsReturnUrl" type="hidden" name="wsReturnUrl" value={encodedURI}/>
          <script> </script>
        </form>
      </div>
    );
  }
}

export default IRCTCCaptchaPage;
